import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

export default function SubscriptionSuccess() {
  const { refresh } = useAuth();

  // Payment is already verified server-side (Razorpay signature check) before we
  // land here; just refresh the session so unlocked state shows everywhere.
  useEffect(() => { refresh(); /* eslint-disable-next-line */ }, []);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-lg p-10 text-center" data-testid="subscription-success-card">
        <CheckCircle2 className="w-14 h-14 text-emerald-600 mx-auto mb-4" />
        <h1 className="text-3xl font-display font-bold tracking-tight text-slate-900">You're subscribed</h1>
        <p className="text-slate-600 mt-2">Every lab is now unlocked. Time to break some AI.</p>
        <Link to="/dashboard">
          <Button className="mt-6 w-full" data-testid="subscription-success-dashboard-button">Go to dashboard</Button>
        </Link>
        <Link to="/labs">
          <Button variant="outline" className="mt-2 w-full">Browse labs</Button>
        </Link>
      </div>
    </div>
  );
}
